import React from "react";
import { useSelector } from "react-redux";

import { objectKeys } from "@nens/shared-utils";

import { PIPE_TYPES } from "../state/layerOneDMenu";
import { getPipesPerType } from "../state/simulation";
import { OneDElementLayerData } from "../utils/layerUtils";

import LayerMenuOneDElementLayerLegendItem from "./LayerMenuOneDElementLayerLegendItem";
import LayerSubMenu from "./LayerSubMenu";

interface Props {
  layerData: OneDElementLayerData;
}

const LayerMenuOneDElementLayerPipes: React.FC<Props> = (props) => {
  const pipesPerType = useSelector(getPipesPerType);
  const { layerData } = props;
  if (!("pipeStyles" in layerData.style)) return null;
  const pipeLayers = layerData.style.pipeStyles;

  const pipes = objectKeys(pipeLayers).map((pipeType) => {
    const pipeConfig = pipeLayers[pipeType];
    const pipeTypeInNumber = Object.keys(PIPE_TYPES).find((key) => PIPE_TYPES[key] === pipeType);

    if (pipeTypeInNumber === undefined) console.error("Cannot find this pipe type", pipeType);

    return {
      pipeTypeInNumber: pipeTypeInNumber !== undefined ? pipeTypeInNumber : "",
      pipeType,
      pipeConfig,
    };
  });

  const pipeConfigs = pipes
    .filter((pipe) => {
      return pipesPerType[pipe.pipeTypeInNumber] !== undefined;
    })
    .filter(
      // filter pipe type that do not contain any element out of the layer menu
      (pipe) => pipesPerType[pipe.pipeTypeInNumber].length !== 0
    );

  return (
    <LayerSubMenu.ItemList>
      <LayerMenuOneDElementLayerLegendItem // Sewer
        indented={false}
        layerConfig={{
          ...layerData.style,
          visible: pipeConfigs.some((item) => {
            return item.pipeConfig.visible === true;
          }),
        }}
      />
      {pipeConfigs.map(
        (
          pipe,
          i // Legends for different pipe types
        ) => (
          <LayerMenuOneDElementLayerLegendItem
            key={i}
            indented
            layerConfig={pipe.pipeConfig}
            layerType={pipe.pipeType}
          />
        )
      )}
    </LayerSubMenu.ItemList>
  );
};

export default LayerMenuOneDElementLayerPipes;
